import { ErrorMessage } from 'components/TextInput'
import { Ref, forwardRef, useContext } from 'react'
import { ThemeContext } from 'styled-components'
import Select from 'react-select'

import { IndicatorsContainer, Option, OptionLeadMerge } from './custom'
import { DropdownContainer, LabelText, RequiredText } from './styles'
import { AsyncDropdownProps, DropdownItem } from './types'
import variants from './variants'
import { GroupBase } from 'react-select'
import SelectType from 'react-select/dist/declarations/src/Select'

const SynchronousAutocomplete = forwardRef<HTMLInputElement, AsyncDropdownProps>(
  (
    {
      error,
      inline,
      isCreatable = false,
      label,
      required,
      showError = true,
      variant = 'simple',
      width = 'auto',
      isSearchOption = false,
      showIcon = true,
      defaultOptions,
      options,
      cacheOptions,
      ...props
    },
    ref,
  ) => {
    const theme = useContext(ThemeContext)
    const variantStyles = variants[variant]

    return (
      <DropdownContainer width={width}>
        {variant === 'labeled' && (
          <LabelText disabled={props.isDisabled}>
            {label}
            {required && <RequiredText>*</RequiredText>}
          </LabelText>
        )}
        <Select
          {...props}
          {...(Array.isArray(defaultOptions) && defaultOptions.length > 0 ? {} : { filterOption: () => true })}
          options={
            options && options?.length > 0
              ? options
              : Array.isArray(defaultOptions) && defaultOptions?.length > 0 && defaultOptions
              ? defaultOptions
              : []
          }
          ref={ref as Ref<SelectType<DropdownItem<string>, false, GroupBase<DropdownItem<string>>>>}
          components={{
            IndicatorsContainer: (p) => IndicatorsContainer(p, showIcon),
            Option: isSearchOption ? OptionLeadMerge : Option,
          }}
          menuPortalTarget={document.body}
          styles={{
            ...variantStyles({ inline, variant, width, theme, error }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
        {error && showError && <ErrorMessage>{error}</ErrorMessage>}
      </DropdownContainer>
    )
  },
)

export default SynchronousAutocomplete
